// @ts-strict-ignore
export const calculation = (
  {
    age,
    retirementAge,
    pensionPot,
    targetAnnualIncome,
    monthlyContribution,
    includeFullStatePension,
    take25PercentTaxFree,
    inflation,
    interest,
  },
  now = Date.now,
) => {
  let retirementPot = pensionPot
  const initialTargetAnnualIncome = targetAnnualIncome
  const ages = []
  const pensionPotData = []
  const d = new Date(now())
  age++
  if (includeFullStatePension) {
    targetAnnualIncome -= 9627.8
  }
  while (pensionPot > 0) {
    if (age > 121) {
      break
    }
    ages.push(age - 1)
    pensionPotData.push(parseFloat(pensionPot.toFixed(2)))
    targetAnnualIncome *= (100 + inflation) / 100
    if (age <= retirementAge) {
      pensionPot += monthlyContribution * 12
      monthlyContribution *= (100 + inflation) / 100
    } else {
      pensionPot -= targetAnnualIncome
    }
    pensionPot *= (100 + inflation + interest) / 100
    if (age === 55 && take25PercentTaxFree) {
      pensionPot *= 0.75
    }

    if (age <= retirementAge) {
      retirementPot = pensionPot
    }

    d.setFullYear(d.getFullYear() + 1)
    age++
  }

  return {
    retirementPot: parseFloat(retirementPot.toFixed(2)),
    yearlyWithdrawal: initialTargetAnnualIncome,
    monthlyWithdrawal: Math.floor(initialTargetAnnualIncome / 12),
    finalPayAge: age - 2,
    ages: ages,
    pensionPotData,
  }
}

export const payout = (params, now = Date.now) => {
  const result = calculation({ ...params, targetAnnualIncome: 10000 }, now)

  const ages = result.ages.filter((a) => a <= params.retirementAge)
  const pensionPotData = result.pensionPotData.slice(0, ages.length)

  return {
    ages,
    pensionPotData,
    finalPayAge: ages[ages.length - 1],
    retirementPot: pensionPotData[pensionPotData.length - 1],
  }
}

export const drawdown = (params, now = Date.now) => {
  const result = calculation({ ...params, age: params.retirementAge }, now)

  return {
    ages: result.ages,
    retirementPot: result.retirementPot,
    pensionPotData: result.pensionPotData,
    finalPayAge: result.finalPayAge,
    monthlyWithdrawal: result.monthlyWithdrawal,
    yearlyWithdrawal: result.yearlyWithdrawal,
  }
}
